var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17796 2.92966L4.62247 1.61874C5.2184 -0.138745 7.67871 -0.207467 8.37182 1.51401L10.904 7.80319C11.5143 9.31891 10.1479 10.8872 8.5629 10.4903L1.69535 8.77055C-0.0976509 8.32157 -0.374256 5.88905 1.27216 5.04897L3.19289 4.06891C3.65715 3.83202 4.01059 3.42326 4.17796 2.92966Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowVector);
export default __webpack_public_path__ + "static/media/yellow-vector.43a63c2d6b54dd9af899978858d8ce18.svg";
export { ForwardRef as ReactComponent };